// extracted by mini-css-extract-plugin
export default {"PageActionLinks":"PageActionLinks_PageActionLinks__IKLNe","confirm":"PageActionLinks_confirm__3RV2x"};